import { getTriggerItemFromResult } from '@/lib/automationTriggers/triggerState.js';
import isDeepEqual from '@/lib/isDeepEqual.js';
import normalizeTriggerItemId from '@/lib/threads/normalizeTriggerItemId.js';
import getScopedExistingArray from '@/redux/reducers/pieveReducer/getScopedExistingArray.js';
import resolveCollectionScopeCompanyId from '@/redux/reducers/pieveReducer/resolveCollectionScopeCompanyId.js';

const upsertTriggerItemFromRequestPayload = ({ state, payload } = {}) => {
  const nextTriggerItem = getTriggerItemFromResult(payload?.data || payload);
  const nextScopeCompanyId = resolveCollectionScopeCompanyId({
    payload,
    state,
    ownerKey: 'triggerItemsScopeCompanyId'
  });

  if (!nextTriggerItem?.id) {
    return state;
  }

  const previousTriggerItems = getScopedExistingArray({
    items: state?.triggerItems,
    ownerCompanyId: state?.triggerItemsScopeCompanyId,
    activeCompanyId: nextScopeCompanyId
  });
  const nextTriggerItems = previousTriggerItems.some((triggerItem) => {
    return normalizeTriggerItemId(triggerItem?.id) === nextTriggerItem.id;
  })
    ? previousTriggerItems.map((triggerItem) => {
        if (normalizeTriggerItemId(triggerItem?.id) !== nextTriggerItem.id) {
          return triggerItem;
        }

        return nextTriggerItem;
      })
    : [...previousTriggerItems, nextTriggerItem];

  if (isDeepEqual(previousTriggerItems, nextTriggerItems) && nextScopeCompanyId === (String(state?.triggerItemsScopeCompanyId || '').trim() || null)) {
    return state;
  }

  return {
    ...state,
    triggerItems: nextTriggerItems,
    triggerItemsScopeCompanyId: nextScopeCompanyId
  };
};

export default upsertTriggerItemFromRequestPayload;
